"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCartCB = exports.updateCart = void 0;
var queue_1 = require("./queue");
var events_1 = require("./events");
var jquery_1 = require("../jquery");
//Promise Flavour
var updateCart = function (lineIndex, quantity) {
    if (quantity === void 0) { quantity = 1; }
    return new Promise(function (resolve, reject) {
        (0, exports.updateCartCB)(lineIndex, quantity, resolve, reject);
    });
};
exports.updateCart = updateCart;
//Callback flavour
var updateCartCB = function (line, quantity, callback, errorCallback) {
    if (quantity === void 0) { quantity = 1; }
    var o = {
        line: line,
        quantity: quantity,
        callback: callback,
        errorCallback: errorCallback,
        url: '/cart/change.js',
        dataType: "json",
        method: 'POST',
        data: {
            line: line,
            quantity: quantity
        },
        action: 'update'
    };
    o.success = function (data) {
        if (this.callback)
            this.callback(data);
        (0, queue_1.addFinishTrigger)({ event: events_1.ON_ITEM_UPDATED, data: data });
        (0, queue_1.removeTask)(this);
        (0, queue_1.nextTask)();
    }.bind(o);
    o.error = function (e, i, a) {
        if (typeof this.errorCallback === "function") {
            this.errorCallback(e ? e.responseJSON || e : 'Unknown Error');
        }
        (0, queue_1.removeTask)(this);
        (0, queue_1.errorQueue)();
    }.bind(o);
    o.task = function () {
        jquery_1.jq.ajax(this);
    }.bind(o);
    (0, queue_1.addTask)(o);
};
exports.updateCartCB = updateCartCB;
//# sourceMappingURL=update.js.map